import { ExpandableSection, ExpandableSectionProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { Quote } from '../../../domain'
import { CoreCoversList } from './CoreCoversList'
import { CoverEndorsements } from './CoverEndorsements'

export interface IncludedCoversExpandableProps extends ExpandableSectionProps {
  quote: Quote
}

export const IncludedCoversExpandable: FunctionComponent<
  IncludedCoversExpandableProps
> = ({ quote, header, ...props }) => {
  return (
    <ExpandableSection header={header} {...props}>
      <CoreCoversList quote={quote} condensed />
      <CoverEndorsements quote={quote} my={3} />
    </ExpandableSection>
  )
}
